<template>
  <Tree
    class="department-select"
    v-if="departments"
    :data="departments"
    :load-data="loadDepartment"
    :showCheckbox="true"
    :showUserCount="true"
    @on-select-change="handleDeptSelect"
    @on-item-check-change="handleDeptItemCheck"
    :childrenKey="childrenKey"
  />
</template>
<script>
import Tree from '../utils/Tree'
import ajax from '@/utils/ajax'
import { DEPARTMENT_INFO } from '@/config/api'

export default {
  name: 'DepartmentSelect',
  components: {
    Tree
  },
  props: {
    selectListProp: Array,
    selectList: Array,
    baseDepartment: Object
  },
  data () {
    return {
      childrenKey: 'children',
      departments: []
    }
  },
  created () {
    this.fetchDepartment().then(departments => {
      departments.forEach(rootNode => {
        this.expandDefaultTree(rootNode)
      })
      this.departments = departments
    })
  },
  watch: {
    selectList (selectList) {
      const tree = this.$children[0]
      tree.getCheckedNodes().forEach(node => {
        tree.updateTreeDown(node, {checked: node.disabled || selectList.includes(node.item_typed_id), indeterminate: false})
      })
    }
  },
  methods: {
    handleDeptSelect (dept) {
    },
    handleDeptCheck (depts) {
      this.$emit('toggle-department')
    },
    handleDeptItemCheck (dept) {
      if (dept.disabled) return
      this.$emit('toggle-contact', dept)
    },
    parserData (response) {
      const data = response.departments || response.department
      if (data && !(Array.isArray(data) && !data.length)) { // when departments is empty
        return [data]
      }
      return data
    },
    fetchDepartment (department_id) {
      return ajax({
        url: DEPARTMENT_INFO,
        data: {
          department_id,
          permission_filter: false
        },
        parser: this.parserData
      })
    },
    loadDepartment (item, callback) {
      this.fetchDepartment(item.id).then(departments => {
        departments.forEach(rootNode => {
          this.expandDefaultTree(rootNode)
        })
        callback && callback(departments[0].children)
        // departments.is_department = true
        // departments.is_group = true
      })
    },
    expandDefaultTree (node) {
      let childrenKey = this.childrenKey
      if (node.has_children_departments) {
        if (node[childrenKey] && node[childrenKey].length) {
          node.expand = true
          node[childrenKey].forEach(child => this.expandDefaultTree(child))
        } else if (!node[childrenKey]) {
          node.loading = false
          node[childrenKey] = []
        }
      }
      node.is_department = true
      node.is_group = true
      node.item_typed_id = 'department-' + node.id
      const selected = this.selectListProp.includes(node.item_typed_id)
      const checked = this.selectList.includes(node.item_typed_id)
      node.disabled = selected
      node.checked = selected || checked
      return node
    }
  }
}
</script>
<style lang="postcss">
.department-select {
  background: #fff;
  padding-left: 15px;
  overflow: auto;
  -webkit-overflow-scrolling: scroll;

}
</style>
